import { cn } from "@/lib/utils";

/**
 * Elegant empty state used across app & admin.
 * Icon is a lucide-react component (passed as prop).
 */
export const EmptyState = ({
  icon: Icon,
  eyebrow,
  title,
  description,
  action,
  className,
  testId,
}) => {
  return (
    <div
      data-testid={testId}
      className={cn(
        "flex flex-col items-start text-left",
        "rounded-2xl border hairline bg-card",
        "p-8 md:p-12",
        "shadow-soft",
        "animate-fade-up",
        className,
      )}
    >
      {Icon && (
        <div className="mb-6 grid place-items-center w-14 h-14 rounded-2xl bg-accent/10 ring-1 ring-accent/30 text-accent">
          <Icon className="w-6 h-6" strokeWidth={1.5} />
        </div>
      )}
      {eyebrow && (
        <span className="overline text-accent mb-3">{eyebrow}</span>
      )}
      <h3 className="font-heading text-2xl sm:text-3xl text-foreground mb-3">
        {title}
      </h3>
      {description && (
        <p className="text-muted-foreground max-w-md leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
};

export default EmptyState;
